"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const Date_1 = __importStar(require("helpers/Date"));
const ReleaseDate = ({ dripping, quizName }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    if (dripping.releaseDays) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.release.days_after_purchase', {
                amountToPluralize: dripping.releaseDays,
                data: { value: dripping.releaseDays }
            }) }));
    }
    if (dripping.releaseDate) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Date_1.default.format(new Date(dripping.releaseDate), Date_1.shortFormatDate) }));
    }
    if (dripping.pageId && quizName) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.release.quiz_approval_name', { quizName }) }));
    }
    if (dripping.pageId) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: t('dripping_2.columns.release.quiz_approval') });
    }
    return ((0, jsx_runtime_1.jsx)("span", { className: "_text-gray-400", children: t('dripping_2.columns.release.as_soon_as_you_buy') }));
};
exports.default = ReleaseDate;
